export default __webpack_public_path__ + "static/media/goshen102.aa8fa135.jpg";